import 'react';
import { useElements, CardNumberElement } from '@stripe/react-stripe-js';

var formatStripeBillingAddress = function formatStripeBillingAddress(a, email) {
  if (!a) {
    return;
  }
  var address = {
    city: (a.city || "").trim(),
    country: a.country.code,
    line1: (a.street[0] || "").trim(),
    line2: "",
    /* eslint-disable camelcase */
    postal_code: (a.postcode || "").replace(/\s/, "")
    /* eslint-enable camelcase */
  };
  if (a.street[1]) {
    var line2 = a.street[1].trim();
    if (line2.length > 0) {
      address.line2 = line2;
    }
  }
  return {
    email: email || "",
    name: "".concat(a.firstname, " ").concat(a.lastname),
    phone: a.telephone,
    address: address
  };
};
var paymentRequestButtonShow = function paymentRequestButtonShow(stripePaymentReq) {
  stripePaymentReq.show();
  return new Promise(function (resolve, reject) {
    if (!stripePaymentReq) {
      return;
    }

    // Remove event listeners
    stripePaymentReq.off("cancel");
    stripePaymentReq.off("paymentmethod");
    stripePaymentReq.on("cancel", function () {
      reject();
    });
    stripePaymentReq.on("paymentmethod", function (ev) {
      if (ev.error) {
        ev.complete("fail");
        reject(new Error(ev.error));
      }
      ev.complete("success");
      resolve(ev);
    });
  });
};
var useCompletePayment = function useCompletePayment(email, billingAddress) {
  var elements = useElements();
  return function (_ref) {
    var stripe = _ref.stripe,
      client = _ref.client,
      paymentMode = _ref.paymentMode,
      paymentMethodID = _ref.paymentMethodID,
      createStripePaymentIntentQuery = _ref.createStripePaymentIntentQuery,
      confirmStripePaymentIntentQuery = _ref.confirmStripePaymentIntentQuery;
    return new Promise(function (resolve, reject) {
      if (!stripe) {
        reject(new Error("Stripe.js hasn't loaded yet."));
      }
      var handleResponse = function handleResponse(response) {
        console.log(response.result);
        switch (response.result) {
          case "success":
            return resolve(response.result);
          case "errorMessage":
            return reject(new Error(response.error));
          case "error":
            return reject(new Error(response.error));
          case "errorInvalidIntentStatus":
            return reject(new Error(response.error));
          case "recreateIntent":
            return createPayment();
          case "requiresAction":
            if (stripe) {
              stripe.handleCardAction(response.clientSecret).then(function (stripeResponse) {
                if (stripeResponse.error) {
                  // Translate stripeResponse.error.code?
                  return reject(new Error(stripeResponse.error.message));
                }
                client(confirmStripePaymentIntentQuery, {
                  intent: stripeResponse.paymentIntent.id
                }).then(function (_ref2) {
                  var confirmStripePaymentIntent = _ref2.confirmStripePaymentIntent;
                  return confirmStripePaymentIntent && handleResponse(confirmStripePaymentIntent);
                });
              });
            }
            break;
        }
      };
      var handlePaymentMethodResponse = function handlePaymentMethodResponse(payload) {
        if (payload.error) {
          return reject(new Error(payload.error.message));
        }
        var paymentId = payload.paymentMethod.id;
        if (typeof paymentId === "undefined") {
          return reject(new Error("NO_PAYMENT_INTENT_ID"));
        }
        client(createStripePaymentIntentQuery, {
          paymentMethod: paymentId
        }).then(function (_ref3) {
          var createStripePaymentIntent = _ref3.createStripePaymentIntent;
          if (createStripePaymentIntent.result !== "success") {
            if (createStripePaymentIntent.error) {
              return reject(new Error(createStripePaymentIntent.error));
            }
          }
          handleResponse(createStripePaymentIntent);
        });
      };
      var createPayment = function createPayment() {
        if (stripe) {
          if (paymentMode === "CARD") {
            var cardNumberElement = elements.getElement(CardNumberElement);
            if (!cardNumberElement) {
              throw new Error("Missing <CardNumberElement />");
            }
            stripe.createPaymentMethod({
              type: "card",
              card: cardNumberElement,
              /* eslint-disable camelcase */
              billing_details: formatStripeBillingAddress(billingAddress, email)
              /* eslint-enable camelcase */
            }).then(function (payload) {
              return handlePaymentMethodResponse(payload);
            });
          } else {
            handlePaymentMethodResponse({
              paymentMethod: {
                id: paymentMethodID
              }
            });
          }
        }
      };
      createPayment();
    });
  };
};

export { paymentRequestButtonShow, useCompletePayment };
//# sourceMappingURL=events.js.map
